const resizeSelectDirective = {
    updated: resizeSelect,
    mounted: resizeSelect,
};

export default resizeSelectDirective;

function resizeSelect(el: HTMLElement) {
    const select = document.createElement('select');
    select.className = el.className;
    const option = document.createElement('option');
    option.textContent = (el as any).value;
    select.appendChild(option);
    // @ts-ignore
    el.parentNode.appendChild(select);
    el.style.width = select.offsetWidth + 'px';
    // @ts-ignore
    select.parentNode.removeChild(select);
}
